import {
  OrderSelectionOptionItem,
  OrderStatusCode,
  ROLE,
} from '../../interface/interface';

export const handleDispensedStatus = (
  groups: unknown,
  allOrderStatus: OrderSelectionOptionItem[],
  commonAdminStatuses: OrderStatusCode[],
) => {
  if (!groups) return [];
  if ((groups as string[])[0] !== ROLE.Admin) {
    return allOrderStatus.filter((s: { id: OrderStatusCode }) =>
      [
        OrderStatusCode.ORDERED,
        OrderStatusCode.DISPENSING,
        OrderStatusCode.DISPENSED,
      ].includes(s?.id),
    );
  } else {
    return allOrderStatus.filter((s) => commonAdminStatuses.includes(s?.id));
  }
};
